export const adminTranslations = {
  en: {
    'admin.title': 'Admin Panel',
    'admin.customerSupport': 'Customer Support',
    'admin.fullAdmin': 'Full Admin',
    'admin.returnToApp': 'Return to Main App',
    'admin.app': 'App',
    'admin.logout': 'Logout',
    'admin.supportAccess': 'Customer Support Access',
    'admin.supportAccessDesc': 'You have limited admin access. Some features may be restricted.',
    'admin.productAdminAccess': 'Product Admin Access',
    'admin.productAdminAccessDesc': 'You have product management access with User Votes permissions.',
    'admin.dashboard': 'Dashboard',
    'admin.analytics': 'Analytics',
    'admin.userManagement': 'User Management',
    'admin.transactionLookup': 'Transaction Lookup',
    'admin.referralCodes': 'Referral Codes',
    'admin.merchantOnboarding': 'Merchant Onboarding',
    'admin.supportTickets': 'Support Tickets',
    'admin.guestConversations': 'Guest Conversations',
    'admin.userVotes': 'User Votes',
    'admin.agentManagement': 'AI Agent Management',
    'admin.clientManagement': 'Client Management',
    'admin.settings': 'Settings',
    'admin.system': 'System Admin',
  },
  es: {
    'admin.title': 'Panel de Administración',
    'admin.customerSupport': 'Soporte al Cliente',
    'admin.fullAdmin': 'Administrador Completo',
    'admin.returnToApp': 'Volver a la Aplicación Principal',
    'admin.app': 'App',
    'admin.logout': 'Cerrar Sesión',
    'admin.supportAccess': 'Acceso de Soporte al Cliente',
    'admin.supportAccessDesc': 'Tienes acceso de administrador limitado. Algunas funciones pueden estar restringidas.',
    'admin.productAdminAccess': 'Acceso de Administrador de Producto',
    'admin.productAdminAccessDesc': 'Tienes acceso a la gestión de productos con permisos de Votos de Usuario.',
    'admin.dashboard': 'Panel de Control',
    'admin.analytics': 'Analíticas',
    'admin.userManagement': 'Gestión de Usuarios',
    'admin.transactionLookup': 'Búsqueda de Transacciones',
    'admin.referralCodes': 'Códigos de Referencia',
    'admin.merchantOnboarding': 'Incorporación de Comerciantes',
    'admin.supportTickets': 'Tickets de Soporte',
    'admin.guestConversations': 'Conversaciones de Invitados',
    'admin.userVotes': 'Votos de Usuarios',
    'admin.agentManagement': 'Gestión de Agentes de IA',
    'admin.clientManagement': 'Gestión de Clientes',
    'admin.settings': 'Configuración',
    'admin.system': 'Administración del Sistema',
  },
  fr: {
    'admin.title': 'Panneau d\'administration',
    'admin.customerSupport': 'Support client',
    'admin.fullAdmin': 'Administrateur complet',
    'admin.returnToApp': 'Retour à l\'application principale',
    'admin.app': 'App',
    'admin.logout': 'Déconnexion',
    'admin.supportAccess': 'Accès au support client',
    'admin.supportAccessDesc': 'Vous avez un accès administrateur limité. Certaines fonctionnalités peuvent être restreintes.',
    'admin.productAdminAccess': 'Accès administrateur produit',
    'admin.productAdminAccessDesc': 'Vous avez accès à la gestion des produits avec les permissions de votes des utilisateurs.',
    'admin.dashboard': 'Tableau de bord',
    'admin.analytics': 'Analytiques',
    'admin.userManagement': 'Gestion des utilisateurs',
    'admin.transactionLookup': 'Recherche de transactions',
    'admin.referralCodes': 'Codes de parrainage',
    'admin.merchantOnboarding': 'Intégration des marchands',
    'admin.supportTickets': 'Tickets de support',
    'admin.guestConversations': 'Conversations des invités',
    'admin.userVotes': 'Votes des utilisateurs',
    'admin.agentManagement': 'Gestion des agents IA',
    'admin.clientManagement': 'Gestion des clients',
    'admin.settings': 'Paramètres',
    'admin.system': 'Administration système',
  },
  sq: {
    'admin.title': 'Paneli i Administratorit',
    'admin.customerSupport': 'Mbështetja për Klientët',
    'admin.fullAdmin': 'Administrator i Plotë',
    'admin.returnToApp': 'Kthehu te Aplikacioni Kryesor',
    'admin.app': 'Aplikacioni',
    'admin.logout': 'Dil',
    'admin.supportAccess': 'Qasja në Mbështetje për Klientët',
    'admin.supportAccessDesc': 'Keni qasje të kufizuar administratori. Disa veçori mund të jenë të kufizuara.',
    'admin.productAdminAccess': 'Qasja në Administratorin e Produktit',
    'admin.productAdminAccessDesc': 'Keni qasje në menaxhimin e produkteve me lejet e Votimeve të Përdoruesve.',
    'admin.dashboard': 'Paneli i Kontrollit',
    'admin.analytics': 'Analitika',
    'admin.userManagement': 'Menaxhimi i Përdoruesve',
    'admin.transactionLookup': 'Kërkimi i Transaksioneve',
    'admin.referralCodes': 'Kodet e Referimit',
    'admin.merchantOnboarding': 'Integrimi i Tregtarëve',
    'admin.supportTickets': 'Biletat e Mbështetjes',
    'admin.guestConversations': 'Bisedat e Vizitorëve',
    'admin.userVotes': 'Votat e Përdoruesve',
    'admin.agentManagement': 'Menaxhimi i Agjentëve të IA',
    'admin.clientManagement': 'Menaxhimi i Klientëve',
    'admin.settings': 'Cilësimet',
    'admin.system': 'Administratori i Sistemit',
  },
  ru: {
    'admin.title': 'Панель администратора',
    'admin.customerSupport': 'Поддержка клиентов',
    'admin.fullAdmin': 'Полный администратор',
    'admin.returnToApp': 'Вернуться в основное приложение',
    'admin.app': 'Приложение',
    'admin.logout': 'Выйти',
    'admin.supportAccess': 'Доступ к поддержке клиентов',
    'admin.supportAccessDesc': 'У вас ограниченный доступ администратора. Некоторые функции могут быть ограничены.',
    'admin.productAdminAccess': 'Доступ администратора продуктов',
    'admin.productAdminAccessDesc': 'У вас есть доступ к управлению продуктами с разрешениями на голоса пользователей.',
    'admin.dashboard': 'Панель управления',
    'admin.analytics': 'Аналитика',
    'admin.userManagement': 'Управление пользователями',
    'admin.transactionLookup': 'Поиск транзакций',
    'admin.referralCodes': 'Реферальные коды',
    'admin.merchantOnboarding': 'Интеграция продавцов',
    'admin.supportTickets': 'Тикеты поддержки',
    'admin.guestConversations': 'Разговоры гостей',
    'admin.userVotes': 'Голоса пользователей',
    'admin.agentManagement': 'Управление AI агентами',
    'admin.clientManagement': 'Управление клиентами',
    'admin.settings': 'Настройки',
    'admin.system': 'Системный администратор',
  },
  pt: {
    'admin.title': 'Painel Administrativo',
    'admin.customerSupport': 'Suporte ao Cliente',
    'admin.fullAdmin': 'Administrador Completo',
    'admin.returnToApp': 'Voltar para o App Principal',
    'admin.app': 'App',
    'admin.logout': 'Sair',
    'admin.supportAccess': 'Acesso de Suporte ao Cliente',
    'admin.supportAccessDesc': 'Você tem acesso administrativo limitado. Alguns recursos podem estar restritos.',
    'admin.productAdminAccess': 'Acesso de Administrador de Produto',
    'admin.productAdminAccessDesc': 'Você tem acesso de gerenciamento de produtos com permissões de Votos de Usuário.',
    'admin.dashboard': 'Painel',
    'admin.analytics': 'Analíticas',
    'admin.userManagement': 'Gerenciamento de Usuários',
    'admin.transactionLookup': 'Consulta de Transações',
    'admin.referralCodes': 'Códigos de Indicação',
    'admin.merchantOnboarding': 'Integração de Comerciantes',
    'admin.supportTickets': 'Tickets de Suporte',
    'admin.guestConversations': 'Conversas de Convidados',
    'admin.userVotes': 'Votos de Usuários',
    'admin.agentManagement': 'Gerenciamento de Agentes IA',
    'admin.clientManagement': 'Gerenciamento de Clientes',
    'admin.settings': 'Configurações',
    'admin.system': 'Administrador do Sistema',
  },
  de: {
    'admin.title': 'Admin-Panel',
    'admin.customerSupport': 'Kundensupport',
    'admin.fullAdmin': 'Vollständiger Admin',
    'admin.returnToApp': 'Zurück zur Haupt-App',
    'admin.app': 'App',
    'admin.logout': 'Abmelden',
    'admin.supportAccess': 'Kundensupport-Zugriff',
    'admin.supportAccessDesc': 'Sie haben eingeschränkten Admin-Zugriff. Einige Funktionen können eingeschränkt sein.',
    'admin.productAdminAccess': 'Produkt-Admin-Zugriff',
    'admin.productAdminAccessDesc': 'Sie haben Zugriff auf die Produktverwaltung mit Benutzer-Stimmen-Berechtigungen.',
    'admin.dashboard': 'Dashboard',
    'admin.analytics': 'Analysen',
    'admin.userManagement': 'Benutzerverwaltung',
    'admin.transactionLookup': 'Transaktionssuche',
    'admin.referralCodes': 'Empfehlungscodes',
    'admin.merchantOnboarding': 'Händler-Onboarding',
    'admin.supportTickets': 'Support-Tickets',
    'admin.guestConversations': 'Gast-Gespräche',
    'admin.userVotes': 'Benutzer-Stimmen',
    'admin.agentManagement': 'KI-Agenten-Verwaltung',
    'admin.clientManagement': 'Kundenverwaltung',
    'admin.settings': 'Einstellungen',
    'admin.system': 'System-Admin',
  },
  ro: {
    'admin.title': 'Panou Administrativ',
    'admin.customerSupport': 'Suport Clienți',
    'admin.fullAdmin': 'Administrator Complet',
    'admin.returnToApp': 'Înapoi la Aplicația Principală',
    'admin.app': 'Aplicație',
    'admin.logout': 'Deconectare',
    'admin.supportAccess': 'Acces Suport Clienți',
    'admin.supportAccessDesc': 'Aveți acces administrativ limitat. Unele funcții pot fi restricționate.',
    'admin.productAdminAccess': 'Acces Administrator Produse',
    'admin.productAdminAccessDesc': 'Aveți acces la gestionarea produselor cu permisiuni de Voturi Utilizator.',
    'admin.dashboard': 'Panou de Control',
    'admin.analytics': 'Analitică',
    'admin.userManagement': 'Gestionare Utilizatori',
    'admin.transactionLookup': 'Căutare Tranzacții',
    'admin.referralCodes': 'Coduri de Referință',
    'admin.merchantOnboarding': 'Onboarding Comercianți',
    'admin.supportTickets': 'Tichete Suport',
    'admin.guestConversations': 'Conversații Oaspeți',
    'admin.userVotes': 'Voturi Utilizatori',
    'admin.agentManagement': 'Gestionare Agenți IA',
    'admin.clientManagement': 'Gestionare Clienți',
    'admin.settings': 'Setări',
    'admin.system': 'Administrator Sistem',
  },
  sr: {
    'admin.title': 'Админ панел',
    'admin.customerSupport': 'Подршка клијентима',
    'admin.fullAdmin': 'Пун администратор',
    'admin.returnToApp': 'Повратак на главну апликацију',
    'admin.app': 'Апликација',
    'admin.logout': 'Одјава',
    'admin.supportAccess': 'Приступ подршци клијентима',
    'admin.supportAccessDesc': 'Имате ограничен администраторски приступ. Неке функције могу бити ограничене.',
    'admin.productAdminAccess': 'Приступ администратору производа',
    'admin.productAdminAccessDesc': 'Имате приступ управљању производима са дозволама за корисничке гласове.',
    'admin.dashboard': 'Контролна табла',
    'admin.analytics': 'Аналитика',
    'admin.userManagement': 'Управљање корисницима',
    'admin.transactionLookup': 'Претрага трансакција',
    'admin.referralCodes': 'Реферални кодови',
    'admin.merchantOnboarding': 'Увођење трговаца',
    'admin.supportTickets': 'Тикети подршке',
    'admin.guestConversations': 'Разговори гостију',
    'admin.userVotes': 'Кориснички гласови',
    'admin.agentManagement': 'Управљање АИ агентима',
    'admin.clientManagement': 'Управљање клијентима',
    'admin.settings': 'Подешавања',
    'admin.system': 'Системски администратор',
  },
  pl: {
    'admin.title': 'Panel administracyjny',
    'admin.customerSupport': 'Obsługa klienta',
    'admin.fullAdmin': 'Pełny administrator',
    'admin.returnToApp': 'Powrót do głównej aplikacji',
    'admin.app': 'Aplikacja',
    'admin.logout': 'Wyloguj',
    'admin.supportAccess': 'Dostęp do obsługi klienta',
    'admin.supportAccessDesc': 'Masz ograniczony dostęp administratora. Niektóre funkcje mogą być ograniczone.',
    'admin.productAdminAccess': 'Dostęp administratora produktu',
    'admin.productAdminAccessDesc': 'Masz dostęp do zarządzania produktami z uprawnieniami do głosów użytkowników.',
    'admin.dashboard': 'Panel',
    'admin.analytics': 'Analityka',
    'admin.userManagement': 'Zarządzanie użytkownikami',
    'admin.transactionLookup': 'Wyszukiwanie transakcji',
    'admin.referralCodes': 'Kody polecające',
    'admin.merchantOnboarding': 'Wprowadzanie sprzedawców',
    'admin.supportTickets': 'Zgłoszenia wsparcia',
    'admin.guestConversations': 'Rozmowy gości',
    'admin.userVotes': 'Głosy użytkowników',
    'admin.agentManagement': 'Zarządzanie agentami AI',
    'admin.clientManagement': 'Zarządzanie klientami',
    'admin.settings': 'Ustawienia',
    'admin.system': 'Administrator systemu',
  },
  el: {
    'admin.title': 'Πίνακας Διαχείρισης',
    'admin.customerSupport': 'Υποστήριξη Πελατών',
    'admin.fullAdmin': 'Πλήρης Διαχειριστής',
    'admin.returnToApp': 'Επιστροφή στην Κύρια Εφαρμογή',
    'admin.app': 'Εφαρμογή',
    'admin.logout': 'Αποσύνδεση',
    'admin.supportAccess': 'Πρόσβαση Υποστήριξης Πελατών',
    'admin.supportAccessDesc': 'Έχετε περιορισμένη πρόσβαση διαχειριστή. Ορισμένες λειτουργίες μπορεί να είναι περιορισμένες.',
    'admin.productAdminAccess': 'Πρόσβαση Διαχειριστή Προϊόντων',
    'admin.productAdminAccessDesc': 'Έχετε πρόσβαση στη διαχείριση προϊόντων με δικαιώματα Ψήφων Χρηστών.',
    'admin.dashboard': 'Πίνακας Ελέγχου',
    'admin.analytics': 'Αναλυτικά',
    'admin.userManagement': 'Διαχείριση Χρηστών',
    'admin.transactionLookup': 'Αναζήτηση Συναλλαγών',
    'admin.referralCodes': 'Κωδικοί Παραπομπής',
    'admin.merchantOnboarding': 'Ενσωμάτωση Εμπόρων',
    'admin.supportTickets': 'Αιτήματα Υποστήριξης',
    'admin.guestConversations': 'Συνομιλίες Επισκεπτών',
    'admin.userVotes': 'Ψήφοι Χρηστών',
    'admin.agentManagement': 'Διαχείριση Πρακτόρων AI',
    'admin.clientManagement': 'Διαχείριση Πελατών',
    'admin.settings': 'Ρυθμίσεις',
    'admin.system': 'Διαχειριστής Συστήματος',
  },
};
